import { render, staticRenderFns } from "./ShowTweets.vue?vue&type=template&id=2844278d&"
import script from "./ShowTweets.vue?vue&type=script&lang=js&"
export * from "./ShowTweets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports